import Index from '../components/Copyright/Index'
import Create from '../components/Copyright/Create'
import Confirm from '../components/Copyright/Confirm'
import SplitConfirm from '../components/Copyright/Split/Confirm'
import Completed from '../components/Copyright/Completed'
import CopyrightSplits from '../components/Copyright/Split/Index'
import CopyrightSplitsDetail from '../components/Copyright/Split/SplitDetail'
import InvitationCode from '../components/Copyright/Split/InvitationCode'
import ConfirmAppliedCopyrightSplit from '../components/Copyright/Split/ConfirmAppliedCopyrightSplit'
import ApprovalCompleted from '../components/Copyright/Split/ApprovalCompleted'
import CopyrightSplitsCancel from '../components/Copyright/Split/CopyrightSplitsCancel'

export default [
  {
    path: '/client/copyright',
    name: 'copyright-index',
    meta: {
      sideMenuId: 'copyright-index',
    },
    component: Index,
  },
  {
    path: '/client/copyright-create',
    name: 'copyright-create',
    meta: {
      sideMenuId: 'copyright-index',
    },
    component: Create,
  },
  {
    path: '/client/copyright/edit/:id',
    name: 'copyright-edit',
    props: {
      isEdit: true,
    },
    meta: {
      sideMenuId: 'copyright-index',
    },
    component: Create,
  },
  {
    path: '/client/copyright/confirm/:id',
    name: 'copyright-confirm',
    meta: {
      sideMenuId: 'copyright-index',
    },
    component: Confirm,
  },
  {
    path: '/client/copyright/tracks/:id',
    name: 'get-track',
    props: {
      isEditTrack: true,
    },
    meta: {
      sideMenuId: 'copyright-index',
    },
    component: Create,
  },
  {
    path: '/client/copyright/completed',
    name: 'copyright-completed',
    component: Completed,
    meta: {
      sideMenuId: 'copyright-index',
    },
  },
  {
    path: '/client/copyright/splits',
    name: 'copyright-splits',
    meta: {
      sideMenuId: 'copyright-splits',
    },
    component: CopyrightSplits,
  },
  {
    path: '/client/copyright/splits/:id',
    name: 'copyright-splits-detail',
    meta: {
      sideMenuId: 'copyright-splits',
    },
    component: CopyrightSplitsDetail,
  },
  {
    path: '/client/copyright/invitation-code',
    name: 'copyright-splits-invitation-code',
    meta: {
      sideMenuId: 'copyright-splits',
    },
    component: InvitationCode,
  },
  {
    path: '/client/copyright/confirm-copyright-split/:splitId',
    name: 'copyright-splits-confirm-applied',
    meta: {
      sideMenuId: 'copyright-splits',
    },
    component: ConfirmAppliedCopyrightSplit,
  },
  {
    path: '/client/copyright-split/approval-completed',
    name: 'copyright-splits-approval-completed',
    meta: {
      sideMenuId: 'copyright-splits',
    },
    component: ApprovalCompleted,
  },
  {
    path: '/client/copyright-split/cancelled',
    name: 'copyright-splits-cancel',
    meta: {
      sideMenuId: 'copyright-splits',
    },
    component: CopyrightSplitsCancel,
  },
  {
    path: '/client/copyright/split-confirm/:id',
    name: 'copyright-split-confirm',
    meta: {
      sideMenuId: 'copyright-splits',
    },
    component: SplitConfirm,
    props: {
      pending: true,
    },
  },
]
